import { render, staticRenderFns } from "./ProductsEdit.vue?vue&type=template&id=2c2fe458&"
import script from "./ProductsEdit.vue?vue&type=script&lang=js&"
export * from "./ProductsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports